export default __webpack_public_path__ + "static/media/Swiss-home-care-liquid-1.e2a132e6.jpg";